import { convertTimestampToDate } from 'helpers';
import { Consignment } from 'types';

export function consignmentFactory(params: any = {}): Consignment {
  const {
    consignmentCode,
    createdDate,
    consignmentStatus,
    salesMode,
    customerName,
    startTimer,
    endTimer,
    deliveryModeId,
    isCollected,
    isLate,
    reservedPOSName,
    availableStores,
    daysToDelivery,
    superExpress,
  } = params;

  return {
    consignmentCode: consignmentCode || '',
    createdDate: convertTimestampToDate(createdDate || 0),
    consignmentStatus: consignmentStatus || '',
    salesMode: salesMode || '',
    customerName: customerName || '',
    startTimer: convertTimestampToDate(startTimer || 0),
    endTimer: convertTimestampToDate(endTimer || 0),
    deliveryModeId: deliveryModeId || '',
    isCollected: isCollected || false,
    isLate: isLate || false,
    reservedPOSName: reservedPOSName || '',
    availableStores: availableStores || [],
    daysToDelivery: daysToDelivery,
    isSuperExpress: superExpress || false,
  };
}

export function consignmentGetFactory(params: any = {}): Consignment[] {
  return params.map((elem: any) => {
    return consignmentFactory(elem);
  });
}
